import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PvtRoute = ({ children: routeConfig }) => {
  const location = useLocation();
  const RoutePage = routeConfig.component;

  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");

  const currentPath = location.pathname;

  const roles = JSON.parse(
    localStorage.getItem("roles") || sessionStorage.getItem("roles") || "[]"
  );

  const hasAccess = (userRoles) => {
    if (!userRoles || userRoles.length === 0) return false;

    const allowedRoles = routeConfig?.role;

    if (!allowedRoles) return true;

    return allowedRoles.some((role) =>
      userRoles.map((r) => r.toLowerCase()).includes(role.toLowerCase())
    );
  };


  if (
    token &&
    (currentPath === "/" ||
      currentPath === "/login" ||
      currentPath === "/register")
  ) {
    return <Navigate to="/dashboard" replace />;
  }


  if (!token) {
    if (
      currentPath === "/" ||
      currentPath === "/login" ||
      currentPath === "/register" ||
      currentPath === "/verify-otp"||
      currentPath === "/home"
    ) {
      return <RoutePage />;
    }

    return <Navigate to="/login" replace />;
  }

 
  if (token && !hasAccess(roles)) {
    return <Navigate to="/dashboard" replace />;
  }


  return <RoutePage />;
};

export default PvtRoute;